import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { linkArray, roleNames } from "../constant";
import Navlink from "../common/FormInputs/Navlink";
import { logOut } from "../services/api";
import useExpiredToken from "../utils/useExpiredToken";
import { useToast } from "../utils/Toast";

const OffcanvasSidebar = () => {
  const { pathname } = useLocation();
  const { role } = useSelector((state) => state.auth);
  const token = useSelector((state) => state.auth.jwtToken);
  const expireToken = useExpiredToken();
  const toast = useToast();

  const topLinks = linkArray.slice(0, 6).filter((item) => {
    if (role === roleNames.qa) {
      return item.title !== "Assign calls" && item.title !== "Manage QAs";
    }
    return true;
  });

  const bottomLinks = linkArray.slice(6);

  const handleLogout = async () => {
    const res = await logOut("auth/logout", token, {});
    if (res) {
      toast.success(res.data);
      setTimeout(() => {
        expireToken();
      }, 1000);
    }
  };

  return (
    <div
      className="offcanvas offcanvas-start"
      tabIndex="-1"
      id="offcanvasSidebar"
      aria-labelledby="offcanvasSidebarLabel"
    >
      <div className="offcanvas-body">
        <div>
          <div className="logo px-3 py-4 sider-css">
            <a href="#">
              <img src="/assets/logo.png" alt="Logo" width={150} />
            </a>
          </div>
          <nav className="nav flex-column px-3">
            {topLinks &&
              topLinks?.map((item, i) => (
                <Navlink
                  key={i}
                  pathname={pathname}
                  item={item}
                  role={role}
                  handleLogout={handleLogout}
                />
              ))}
          </nav>
        </div>

        <div className="bottom-links px-3">
          {bottomLinks &&
            bottomLinks?.map((item, i) => (
              <Navlink
                key={i}
                pathname={pathname}
                item={item}
                role={role}
                handleLogout={handleLogout}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default OffcanvasSidebar;
